





































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Info from './Service/Info';
import Delete from './Service/Delete';
import depForm from './form';
import create from './create.vue';
import modify from './modify.vue';
import doModify from './Service/DoModify';

@Component({
  components: { create, modify },
})
export default class department extends Vue {
  private loading: boolean = false;

  private depForm: Object = depForm;

  private dialogCreate: boolean = false;

  private dialogModify: boolean = false;

  // 上層部門ID
  private dnt_pid: any = null;

  // 部門樹
  private dnt_tree: any = [];
  private modify_data: any = {};

  /**
   * getInfo 取得資料
   */
  public async getInfo() {
    const getter = (await new Info().get()) as any;
    this.dnt_tree = getter.p6_department_position_f;
  }

  public async position(data: any) {
    this.$router.push({
      path: '/organization/department-account/info',
      query: {
        p6_dpn_id: data.p6_dpn_id,
        p6_dpn_name: data.p6_dpn_name,
      },
    });
  }

  public async append(data: any) {
    this.dnt_pid = data.p6_dpn_id;
    this.dialogCreate = true;
  }

  public async modify(data: any) {
    this.modify_data = data;
    this.dialogModify = true;
  }

  /** 刪除功能，可複選 */
  public async doDelete(item: any) {
    const doDelete = (await new Delete(item).delete()) as any;
    if (doDelete.data.code === 0) {
      this.getInfo();
    }
  }

  /** 拖拉功能 */

  public async handleDrop(
    draggingNode: any,
    dropNode: any,
    dropType: any,
    ev: any,
  ) {
    const form = draggingNode.data;
    if (dropType === 'inner') {
      form.p6_dpn_pid = dropNode.data.p6_dpn_id;
    }
    if (dropType === 'after' || dropType === 'before') {
      form.p6_dpn_pid = dropNode.data.p6_dpn_pid;
    }

    const getter = (await new doModify(form).put()) as any;
    if (getter.data && getter.data.code === 0) {
      this.getInfo();
    }
  }

  public async handleDragEnd(
    draggingNode: any,
    dropNode: any,
    dropType: any,
    ev: any,
  ) {}

  private mounted() {
    this.$store.dispatch('setBread', {
      href: '',
      label: `${this.$t('Organization.department.position')}`,
    });
    /** 從bus偵測新增行為 */
    this.$bus.$on('create', () => {
      this.dnt_pid = null;
      this.dialogCreate = true;
    });
    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('modify', () => {
      this.$router.push(
        `/account/manage/modify?p3_ant_id=${this.$route.query.p3_ant_id}`,
      );
    });

    this.getInfo();
  }
}
